import { createSlice } from "@reduxjs/toolkit";

const appbarSlice = createSlice({
  name: "appbar",
  initialState: false,
  reducers: {
    toggle: (state) => {
      return !state;
    },
    close: (state) => {
      return (state = false);
    },
  },
});

export const { toggle, close } = appbarSlice.actions;
export default appbarSlice.reducer;
